import { useTranslation } from 'react-i18next';
import type { FieldValue } from '@platform/core/types';
import { usePatchRecordMutation } from '@platform/state/api';
import { InlineField } from '../../fields/InlineField';
import type { ISubTableRowProps } from './ISubTableRowProps';

/**
 * Рядок підтаблиці «Подробиці» (прототип v4, subSecs): лише колонки визначення — ті самі контроли, що у формі, розміру inline (прозорі до
 * наведення, порожня клітинка — «—»); як у прототипі, редагуються й у режимі перегляду батьківської форми: вибір зберігається одразу,
 * текст — за Enter чи виходом із клітинки (зміна дочірнього запису з версією рядка, історію пише сервер); без права зміни — лише читання.
 * × — вилучення рядка (з підтвердженням).
 */
export function SubTableRow({ ws, child, record, fields, grid, readOnly, onRemove }: ISubTableRowProps) {
  const { t } = useTranslation();
  const [patch] = usePatchRecordMutation();
  const locked = readOnly || record.permissions?.edit === false;
  const valueOf = (key: string): unknown => (key === 'status' ? record.status : key === 'title' ? record.title : record.values[key] ?? (record.ext[key] as FieldValue | undefined));
  const commit = (key: string, value: unknown) => void patch({ ws, rt: child.key, id: record.id, body: { values: { [key]: value } }, rowVersion: record.rowVersion });
  return (
    <div className="rec-subcard__row" style={grid}>
      {fields.map((f) => (
        <span key={f.key} className="rec-subcard__cell">
          <InlineField field={f} rt={child} ws={ws} record={record} value={valueOf(f.key)} readOnly={locked}
            emptyChoice={t('recordPage.general.emptyCell')} onCommit={(v) => commit(f.key, v)} />
        </span>
      ))}
      {onRemove && (
        <button type="button" className="rec-subcard__x" aria-label={t('recordPage.general.removeRow')} title={t('recordPage.general.removeRow')}
          onClick={() => onRemove(record)}>×</button>
      )}
    </div>
  );
}
